import type { Infer, Struct } from 'superstruct';
import { array, coerce, mask, string } from 'superstruct';

/**
 * Allows arrays serialized as strings with a separator to be parsed.
 *
 * Note: If the array type is not string, it should allow for coercions from
 * string to the desired type.
 *
 * @example
 * create('1,2,3', parsableArray(parsableInteger()), ',')
 * // returns [1, 2, 3]
 */
export const parsableArray = <T extends Struct<unknown, unknown>>(
	type: T,
	separator = ','
): Struct<Infer<T>[], T> => {
	return coerce(array(type), string(), (value) => {
		const items = value.split(separator);
		return mask(items, array(type));
	});
};
